var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSegurana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1165_9610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.621 4.55174C17.8116 3.75536 17.7122 1.74609 17.7122 1.74609H6.52926C6.52926 1.74609 6.49359 3.77248 5.62117 4.55174C4.81311 5.27351 2.75629 5.44084 2.75629 5.44084L2.7561 14.0355C2.7561 14.0355 3.50793 16.77 6.14553 19.4076C9.27551 22.5376 12.126 23.7461 12.126 23.7461C12.126 23.7461 14.5184 23.0506 18.1852 19.3837C20.8745 16.6944 21.5057 14.0157 21.5057 14.0157V5.38157C21.5057 5.38157 19.4393 5.35676 18.621 4.55174Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5595 9.1791H14.9881V8.03622C14.9881 6.45904 13.708 5.17901 12.1309 5.17901C10.5537 5.17901 9.27365 6.45904 9.27365 8.03622V9.1791H8.70221C8.07362 9.1791 7.55933 9.6934 7.55933 10.322V16.0364C7.55933 16.665 8.07362 17.1793 8.70221 17.1793H15.5595C16.1881 17.1793 16.7024 16.665 16.7024 16.0364V10.322C16.7024 9.6934 16.1881 9.1791 15.5595 9.1791ZM10.4165 8.03622C10.4165 7.08762 11.1823 6.32189 12.1309 6.32189C13.0795 6.32189 13.8452 7.08762 13.8452 8.03622V9.1791H10.4165V8.03622ZM15.5595 16.0364H8.70221V10.322H15.5595V16.0364ZM12.1309 14.3221C12.7594 14.3221 13.2737 13.8078 13.2737 13.1792C13.2737 12.5506 12.7594 12.0363 12.1309 12.0363C11.5023 12.0363 10.988 12.5506 10.988 13.1792C10.988 13.8078 11.5023 14.3221 12.1309 14.3221Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1165_9610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.130859 0.746094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegurana);
export default __webpack_public_path__ + "static/media/Segurança.a81f34df3e7e40d2c6a5dd302fa7a4d1.svg";
export { ForwardRef as ReactComponent };